import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ProgressTopicsDropdown from 'pages/VocabularyTest/components/ProgressTopicsDropdown';
import { VocabularyTestTopic } from 'app/types';
import UIFlex from 'components/ui/UIFlex';
import FilledActionButton from 'components/FilledActionButton';
import { DESKTOP_LAYOUT_BREAKPOINT } from 'pages/VocabularyTest/utils';

interface IStageNavProps {
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onFinish: () => void;
  progress: number;
  testTopics: VocabularyTestTopic[];
}

const StageNav: React.FC<IStageNavProps> = ({
  canGoPrevious,
  canGoNext,
  onPrevious,
  onNext,
  onFinish,
  progress,
  testTopics,
}) => {
  // NOTE: FilledActionButton merges its `sx` via object spread ({...sx}),
  // which silently drops a *function* sx — so responsive overrides can't be
  // expressed with `sx={(theme) => ({ [breakpoints.up(...)]: ... })}` here.
  // Resolve the breakpoint to a boolean and feed plain object sx instead.
  const theme = useTheme();
  const isDesktop = useMediaQuery(
    theme.breakpoints.up(DESKTOP_LAYOUT_BREAKPOINT),
  );

  return (
    <UIFlex
      alignItems={'center'}
      justifyContent={'space-between'}
      sx={{ flexWrap: 'wrap', gap: 2, py: 1 }}
    >
      <ProgressTopicsDropdown progress={progress} testTopics={testTopics} />

      {/* Завершити тест lives in the sticky bar on desktop — below the
          desktop cutoff there's no room for it there alongside the status
          buttons, so it moves down here instead, its own full-width row
          above Попередні/Наступні. */}
      {!isDesktop && (
        <FilledActionButton
          onClick={onFinish}
          startIcon={<DoneAllIcon />}
          sx={{ flex: '1 1 100%', height: 42, order: 1 }}
        >
          {'Завершити тест'}
        </FilledActionButton>
      )}

      <FilledActionButton
        disabled={!canGoPrevious}
        onClick={onPrevious}
        startIcon={<ArrowBackIcon />}
        sx={{
          flex: isDesktop ? '0 0 auto' : '1 1 45%',
          height: 42,
          order: isDesktop ? 0 : 2,
        }}
      >
        {'Попередні категорії'}
      </FilledActionButton>

      <FilledActionButton
        disabled={!canGoNext}
        endIcon={<ArrowForwardIcon />}
        onClick={onNext}
        sx={{
          flex: isDesktop ? '0 0 auto' : '1 1 45%',
          height: 42,
          order: isDesktop ? 2 : 3,
        }}
      >
        {'Наступні категорії'}
      </FilledActionButton>
    </UIFlex>
  );
};

export default StageNav;
